.root {
  display: flex;
  flex-direction: column;
}

.title {
  margin-top: 8px;
  margin-bottom: 4px;
}

.help {
  color: var(--tuna-palette-text-secondary);
}
